import axios from "../../utils/axios";
import { 
    ENDPOINT_COMPANY_SETTINGS, 
    ENDPOINT_COMPANY_SETTINGS_UPDATE,
    ENDPOINT_COMPANY_SETTINGS_SECTION_UPDATE,
    ENDPOINT_COMPANY_SETTINGS_VALIDATE,
    ENDPOINT_COMPANY_SETTINGS_AUDIT
} from "../../constants";
import { CompanySettings, SettingSection, ValidationRequest, ValidationResponse } from "./data";
import { ApiResponse } from "../types";
import { handleApiError, apiCallWithRetry } from "../../utils/error_handler";

// Retrieve company settings
export async function retrieveCompanySettings(): Promise<CompanySettings> {
    try {
        const res = await apiCallWithRetry(() =>
            axios.get<ApiResponse<CompanySettings>>(ENDPOINT_COMPANY_SETTINGS)
        );
        if (res.data.Code !== '200') {
            throw handleApiError({ response: { data: res.data } });
        }
        return res.data.Msg as CompanySettings;
    } catch (error: any) {
        throw handleApiError(error);
    }
}

// Update all company settings
export async function updateCompanySettings(settings: CompanySettings): Promise<void> {
    try {
        const res = await apiCallWithRetry(() =>
            axios.post<ApiResponse<void>>(ENDPOINT_COMPANY_SETTINGS_UPDATE, settings),
            { skipRetry: true }  // Skip retry for POST operations
        );
        if (res.data.Code !== '200') {
            throw handleApiError({ response: { data: res.data } });
        }
    } catch (error: any) {
        throw handleApiError(error);
    }
}

// Update a specific section of settings
export async function updateSettingSection(section: string, data: SettingSection): Promise<void> {
    try {
        const res = await apiCallWithRetry(() =>
            axios.post<ApiResponse<void>>(ENDPOINT_COMPANY_SETTINGS_SECTION_UPDATE + `?section=${section}`, data),
            { skipRetry: true }  // Skip retry for POST operations
        );
        if (res.data.Code !== '200') {
            throw handleApiError({ response: { data: res.data } });
        }
    } catch (error: any) {
        throw handleApiError(error);
    }
}

// Validate settings before applying
export async function validateSettings(request: ValidationRequest): Promise<ValidationResponse> {
    try {
        const res = await apiCallWithRetry(() =>
            axios.post<ApiResponse<ValidationResponse>>(ENDPOINT_COMPANY_SETTINGS_VALIDATE, request),
            { skipRetry: true }  // Skip retry for POST operations
        );
        if (res.data.Code !== '200') {
            throw handleApiError({ response: { data: res.data } });
        }
        return res.data.Msg as ValidationResponse;
    } catch (error: any) {
        throw handleApiError(error);
    }
}

// Retrieve audit trail for settings changes
export async function retrieveAuditTrail(): Promise<any> {
    try {
        const res = await apiCallWithRetry(() =>
            axios.get<ApiResponse<any>>(ENDPOINT_COMPANY_SETTINGS_AUDIT)
        );
        if (res.data.Code !== '200') {
            throw handleApiError({ response: { data: res.data } });
        }
        return res.data.Msg;
    } catch (error: any) {
        throw handleApiError(error);
    }
}